import EditProjectPage from './EditProjectPage';

export default EditProjectPage;
